import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {PlgEntityModel} from "../plg-entity.model";
import {PlgData, PlgSellableData} from "../plg.data";
import {
    ProductLineSearchPageComponent
} from "../../product-line/product-line-search-page/product-line-search-page.component";
import {ProductLineEditPageComponent} from "../../product-line/product-line-edit-page/product-line-edit-page.component";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "plg-edit-page",
    templateUrl: "./plg-edit-page.component.html",
    providers: [provideEntityModel(PlgEntityModel)]
})
export class PlgEditPageComponent extends AbstractEditPage {
    ProductLineSearchPageComponent = ProductLineSearchPageComponent;
    ProductLineEditPageComponent = ProductLineEditPageComponent;
    EditMode = EditMode;

    constructor(public model: PlgEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    sellableLineSaved(changed: PlgSellableData): void {
        if (changed.defaultSellable) {
            this.model.data.sellableLines.forEach((plgSellable: PlgSellableData) => {
                if (changed !== plgSellable) {
                    plgSellable.defaultSellable = false;
                }
            });
        }
    }

    addingAnother(previousEntity: PlgData): void {
        this.model.data.primaryCategory.categoryId = previousEntity.primaryCategory.categoryId;
    }
}
